import { HttpClient } from '@angular/common/http';
import { RESTObject } from '../angular-rest';

export interface IColoreEvento {
    nome: string;
    colore: string;
}

export class ColoreEvento extends RESTObject<IColoreEvento> {
    public nome: string;
    public colore: string; // FIXME: colore non dovrebbe servire...

    constructor($http: HttpClient, uri: string, initialValue: IColoreEvento) {
        super($http, uri, initialValue);
        this.nome = initialValue.nome;
        this.colore = initialValue.colore;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/colore_evento.ts